// App Version for Cache Busting
// Har change ke baad version increment karo

export const APP_VERSION = '1.0.1';
export const BUILD_DATE = new Date().toISOString();

// Cache-busting ke liye use karo:
// /images/logo.png?v=1.0.1
